import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation(); 
  return (
    <footer>
      <p>{t('footer.name')} © {new Date().getFullYear()}</p>
      <p>{t('footer.contact')} : info@villa-santeodoro.com</p>
      <p>{t('footer.telLAbel')} : +39 376 282 4580</p>
      <p>CIN : IT090092B4000T9984</p>
      <a
        href="https://www.facebook.com/pinaepaolo"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
        className="footer-facebook-link"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden="true"
          style={{ verticalAlign: 'middle' }}
        >
          <path d="M22.675 0h-21.35C.595 0 0 .592 0 1.326v21.348C0 23.408.595 24 1.325 24h11.495v-9.294H9.691v-3.622h3.129V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.797.143v3.24l-1.918.001c-1.504 0-1.797.715-1.797 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116C23.405 24 24 23.408 24 22.674V1.326C24 .592 23.405 0 22.675 0"/>
        </svg>
      </a>
      <div>
        <a href="/admin" className="footer-login-btn">Connexion</a>
      </div>
    </footer>
  );
};

export default Footer;
